export default __webpack_public_path__ + "static/media/tictactoe.1b0da454.png";